// src/layouts/PublicLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ChatAssistant from "../components/ChatAssistant";
import FloatingContactButton from "../components/FloatingContactButton";

export default function PublicLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-tr from-dualStart to-dualEnd text-white font-sans">
      <Header />
      <main className="flex-grow container mx-auto px-6 md:px-12 py-10" style={{ maxWidth: "100%" }}>
        <Outlet />
      </main>
      <Footer />
      <ChatAssistant />
      <FloatingContactButton />
    </div>
  );
}
